<template>
  <div>
    <TemplateBookBookingResultProcessing />
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

import TemplateBookBookingResultProcessing from "@/views/Templates/TicketStore/TemplateBookBookingResultProcessing";

export default {
  name: "BookBookingResultProcessing",
  components: {
    TemplateBookBookingResultProcessing: TemplateBookBookingResultProcessing,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    store.commit("ticketing/setPaymentProcessInfo", null);

    onMounted(async () => {
      try {
        console.log("route::", route);

        //get payment process
        await API.getPaymentProcessInfo(route.params.process_id, "ticketing");
      } catch (err) {
        console.log(err);
      }
    });

    return {};
  },
};
</script>
